import type { Pinia, StateTree, Store } from 'pinia';

const GLOBAL_STORE_IDS = new Set(['user', 'app', 'auth', 'menu', 'webSocket', 'systemStatus', 'pagePerfLogger', 'monitoring']);

type PiniaWithStoreMap = Pinia & {
    _s: Map<string, Store>;
    state: { value: Record<string, StateTree> };
};

export function resetPageStores(pinia: Pinia): void {
    const piniaWithStoreMap = pinia as PiniaWithStoreMap;

    piniaWithStoreMap._s.forEach((store, storeId) => {
        if (GLOBAL_STORE_IDS.has(storeId)) {
            return;
        }

        store.$dispose();
        delete piniaWithStoreMap.state.value[storeId];
    });
}
